import { FetchEtherscan } from "../fetch-etherscan"

const ETHERSCAN_API_KEY = process.env.REACT_APP_ETHERSCAN_API_KEY

export const GetEtherscanTransactionByTxHash = async (txHash) => {
    return FetchEtherscan(`?module=account&action=txlistinternal&txhash=${txHash}&apikey=${ETHERSCAN_API_KEY}`)
}